<mat-form-field class="w-full">
  <mat-label>Country</mat-label>
  <input
    type="text"
    placeholder="Type Country Name"
    aria-label="Number"
    matInput
    [required]="isRequired"
    autocomplete="off"
    [formControl]="searchCtrl"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option
      *ngFor="let country of filteredCountries$ | async"
      [value]="country.name"
    >
      {{ country.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
